import { render } from "./DiretorioListToolbar.vue?vue&type=template&id=6aa04159&scoped=true"
import script from "./DiretorioListToolbar.vue?vue&type=script&lang=js"
export * from "./DiretorioListToolbar.vue?vue&type=script&lang=js"

import "./DiretorioListToolbar.vue?vue&type=style&index=0&id=6aa04159&scoped=true&lang=css"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa04159"]])

export default __exports__